// extracted by mini-css-extract-plugin
module.exports = {"outer":"_1sUVC","heading":"_1xe0B","subHeading":"vG_ns"};